import React from "react";
import Card from "react-bootstrap/Card";
import Topbar from "../../components/Topbar";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";
import AdvancedOptions from "../../images/AdvancedOptions.png";
import TxtToImg from "../../components/Generator/TxtToImg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Third lesson; Introduces students to the advanced
// text-to-image generation options, which include
// fields such as seed, steps, and guidance (CFG) scale.

class ThirdLesson extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Advanced Options",
      length: "30 Minutes",
      description: "This lesson will go over the advanced options toggle.",
      topics: ["Advanced Options", "Seeds", "Steps", "Guidance Scale"],
      page: "../lessons/third",
    };
  }

  render() {
    return (
      <div className="lesson" style={{ backgroundColor: "#727c8f" }}>
        <Topbar />
        <div style={{ height: "1vh" }}></div>
        <div className="d-flex justify-content-center">
          <Card>
            <Card.Header className="bg-success text-white text-center">
              <h3>{this.state.title}</h3>
            </Card.Header>
            <Card.Body style={{ maxWidth: "75vw" }}>
              <div className="text-center">
                <Card.Title>Lesson Length: {this.state.length}</Card.Title>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div className="text-center">
                <Image src={AdvancedOptions} width="75%" height="75%" />
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Hello, and welcome to our lesson on the advanced options of
                  our image generator. We will be going over the different
                  advanced options {"(Seed, Steps, and Guidance Scale"} as shown
                  above.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Seeds are like the starting point for the computer to make an
                  image. It's like giving the computer a blank canvas to start
                  with. Seeds are just random numbers that the computer uses to
                  create a starting point for the image.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  If you were to set the seed to the same value every time as
                  well as use the same prompt, you will see the same image
                  generated each time. If the seed box is empty then the created
                  image is essentially random, although there is a very slim
                  chance of getting the same seed twice in a row. Using the same
                  prompt and seed value, you may test out creating the same
                  image twice below{" "}
                  {"(make sure the advanced options switch is flipped)"}:
                </Card.Text>
              </div>
              <Container fluid>
                <Row>
                  <Col md={{ span: 2, offset: 0 }}>
                    <br />

                    <br />
                  </Col>
                  <Col md={{ span: 8, offset: 0 }}>
                    <br />
                    <TxtToImg />
                    <br />
                  </Col>
                  <Col md={{ span: 2, offset: 0 }}>
                    <br />

                    <br />
                  </Col>
                </Row>
              </Container>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Steps are like the number of times the computer has to work on
                  the image to make it better. Each step is like a small
                  improvement to the image. The more steps the computer takes,
                  the better the image gets. However, taking more steps means
                  the computer has to work harder and it can take longer to make
                  the image.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  If you set the number of steps to a higher number rather than
                  a lower number, the image might look better. Using the same
                  prompt and seed value, compare creating an image with 5 steps
                  to creating an image with 50 steps in order to see how the
                  image improves{" "}
                  {"(make sure the advanced options switch is flipped)"}:
                </Card.Text>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Guidance scales are like instructions that are given to the
                  computer to help it make a specific kind of picture. It's like
                  telling the computer what kind of picture you want it to
                  create, and how important that picture is to yourself. You can
                  use guidance scales to help the computer create pictures that
                  have a certain look or feel. For example, if you want the
                  computer to make a picture of a cat, you can use a guidance
                  scale to tell the computer what kind of cat you want it to
                  create. We can tell the computer to make a big cat or a small
                  cat, a brown cat or an orange cat, and so on. The value of the
                  guidance scale is like a score that we give to each
                  instruction. A higher score means that the computer should
                  follow that instruction more closely, while a lower score
                  means that the computer can be more flexible with that
                  instruction.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Using the guidance scale you can give the generator a specific
                  prompt and it will create an image based on the guidance scale
                  value as for how closely it follows the prompt. A lower
                  guidance scale value will not follow the prompt as closely as
                  a higher guidance scale value. Let's test this out by using
                  the same prompt, seed value, and step value to compare a lower
                  guidance scale value of "0.5" with a higher guidance scale
                  value of "99.5"{" "}
                  {"(make sure the advanced options switch is flipped)"}:
                </Card.Text>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  All three of these advanced options can be used to further
                  fine tune image creation compared to the basic options covered
                  in lesson two. Use these advanced options to further improve
                  your images.
                </Card.Text>
              </div>
              <div
                style={{
                  fontSize: "4.0rem",
                  fontWeight: "bold",
                  padding: "1vh",
                }}
              >
                <div className="text-center">Congratulations!</div>
              </div>
              <div
                style={{
                  fontSize: "2.0rem",
                  fontWeight: "bold",
                  padding: "1vh",
                }}
              >
                <div className="text-center">
                  You have completed your third lesson in Diffractive!
                </div>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div className="d-flex justify-content-center">
                <Nav>
                  <Nav.Link id="ThirdReturn" href="../lessons" variant="dark">
                    <Button variant="info">Return to Lessons</Button>
                  </Nav.Link>
                </Nav>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}

export default ThirdLesson;
